export enum RealtimeEncryptionActionType {
  SET_ENCRYPTION_KEY = 'SET_ENCRYPTION_KEY',
  CLEAR_ENCRYPTION_KEY = 'CLEAR_ENCRYPTION_KEY',
}

export interface RealtimeEncryptionKey {
  id: string;
  key: string;
}

export interface RealtimeEncryptionStateAction {
  type: RealtimeEncryptionActionType;
  channel?: string;
  pastKey?: RealtimeEncryptionKey;
  currentKey?: RealtimeEncryptionKey;
  nextKey?: RealtimeEncryptionKey;
}

export function setEncryptionKeys(
  channel: string,
  pastKey: RealtimeEncryptionKey,
  currentKey: RealtimeEncryptionKey,
  nextKey: RealtimeEncryptionKey
): RealtimeEncryptionStateAction {
  return {
    type: RealtimeEncryptionActionType.SET_ENCRYPTION_KEY,
    channel,
    pastKey,
    currentKey,
    nextKey,
  };
}

export function clearEncryptionKeys(channel?: string): RealtimeEncryptionStateAction {
  return {
    type: RealtimeEncryptionActionType.CLEAR_ENCRYPTION_KEY,
    channel,
  };
}
